import React, { useEffect, useState, useRef, useContext } from "react";
import { useSelector } from "react-redux";
import { FaGraduationCap } from "react-icons/fa";
import { FaSchool } from "react-icons/fa";
import { HiMiniIdentification } from "react-icons/hi2";
import { FaPenToSquare } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import { LoadContext } from "../../../ReusableComponents/LoadingContex";
import axiosInstance from "../../../ReusableComponents/Axios";
import { AssessmentName } from "../../../Student/Reusablecomponents/RegularFunctions";
// import "../Assests/Scss/ReportCard.scss";
import { Row, Col } from "react-bootstrap";
import { object } from "yup";
import NSFLOgo from "../../../Student/Assests/Images/NCLogo.png";
import { renderToString } from "react-dom/server";
import { format } from "date-fns";
import { FaSquare } from "react-icons/fa";

const SamagaraReportCard = () => {
    const location = useLocation();
    const { SetLoad } = useContext(LoadContext);
    const ReportsRef = useRef();
    const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const USYear = useSelector((state) => state.SelecYearData.SYear);
    const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
    const [SSS, SetSSS] = useState([]);
    const [Readiness, SetReadiness] = useState([]);
    const [LLD, SetLLD] = useState([]);
    const [FAD, SetFAD] = useState([]);
    const [SPD, SetSPD] = useState([]);
    const FetchallAPIs = async () => {
        SetLoad(true);
        try {
            const [SP, SS, RD, LLT, FA] = await Promise.all([

                axiosInstance.get(
                    `/Principal/GetSubjectGradeWiseParticipationReport?SchoolId=${items.schoolId}&ContestCreationId=${SelectDate?.value}&AssessmentType=3`,
                ),
                axiosInstance.get(
                    `/Principal/GetPrincipalStudentDistributionbyCompetency?SchoolId=${items?.schoolId}&ContestCreationId=${SelectDate?.value}`,
                ),
                axiosInstance.get(
                    `/Principal/GetPrincipalSubjectReadinessDistribution?SchoolId=${items?.schoolId}&ContestCreationId=${SelectDate?.value}`,
                ),
                axiosInstance.get(
                    `/Principal/GetPrincipalLearningLevelTables?SchoolId=${items?.schoolId}&ContestCreationId=${SelectDate?.value}`,
                ),

                axiosInstance.get(
                    `/Principal/GetPrincipalFocusOnLOPerformance?SchoolId=${items?.schoolId}&ContestCreationId=${SelectDate?.value}&AssessmentType=3`,
                ),
            ]);
            if (SP?.data?.[0]?.grade) {
                const SPData = SP?.data.map(item => ({
                    ...item,
                    participatedPercentage: item.registered > 0 > 0 ? Math.round((item.participated / item.registered) * 100) : 0
                }))
                SetSPD(SPData);
            } else {
                SetSPD([]);
            }
            const Overall = {
                performanceLevel: "STUDENTS ASSESSED",
                percent: SS.data?.length
                    ? Math.round(
                        SS.data.reduce((sum, item) => sum + Number(item.percentage), 0) / SS.data.length
                    )
                    : 0,
                percentage: SS.data?.reduce((sum, item) => sum + item.totalUsers, 0,),
                totalUsers: SP?.data?.reduce((sum, item) => sum + item.registered, 0,),
            };
            SetSSS([Overall, ...SS.data]);

            const RData = RD.data
            SetReadiness(RData);

            const LLTData = LLT.data.reduce((acc, item) => {
                if (!acc[item.subjectName]) {
                    acc[item.subjectName] = [];
                }
                acc[item.subjectName].push(item);
                return acc;
            }, {})
            SetLLD(LLTData);

            const FAData = FA.data.reduce((acc, item) => {
                if (!acc[item.subjectName]) {
                    acc[item.subjectName] = {};
                }
                if (!acc[item.subjectName][item.grade]) {
                    acc[item.subjectName][item.grade] = [];
                }

                acc[item.subjectName][item.grade].push(item);
                return acc;
            }, {})
            SetFAD(FAData);
        } catch (err) {
            console.log(err);
        } finally {
            SetLoad(false);
        }
    };
    useEffect(() => {
        FetchallAPIs();
    }, [SelectDate]);

    const SubColors = (Sub) => {
        switch (Sub) {
            case "English":
                return ["#e2efe7", "#16a349", "📗"];
            case "Mathematics":
                return ["#eff6ff", "#2350d3", "📐"];
            case "Science":
                return ["#ec6722", "#ffc7aa"];
            case "Physics and Chemistry":
                return ["#875998", "#dcaded"];
            case "Biology":
                return ["#7d859e", "#e7e7e7"];
            case "OVERALL AVERAGE":
                return ["#effdf9", "#2f6e56", "📊"];
            case "BioTechnology":
                return ["#bb995f", "#d8bc8d"];
            case "Hindi":
                return ["#f96393", "#f9a0bc"];
            case "Telugu":
                return ["#AD46FF", "#d6a2ff"];
            default:
                return ["#5657d4", "#92b5ff"];
        }
    };

    const Percentagecolor = (e) => {
        switch (true) {
            case e <= 50:
                return "#db2626";
            case e > 50 && e <= 74:
                return "#f49e0a";
            case e > 74:
                return "#16a349";
        }
    };

    const InsightsColor = (insight) => {
        switch (insight) {
            case "Competent":
                return ["#16a349", "#166434", "#effdf4", "🌟", "Students Competent"];
            case "Bridge the Gap":
                return ["#f49e0a", "#b35208", "#fffbeb", "📈", "need targeted support"];
            case "Remediation Need":
                return ["#db2626", "#b81c1c", "#fef2f2", "⚠️", "need foundational program"];
            case "STUDENTS ASSESSED":
                return ["#1E3A8A", "#2450D3", "#eff6ff", "👥", "enrolled"];
        }
    }

    const replaceCanvasWithImages = () => {
        const canvases = document.querySelectorAll("canvas");
        canvases.forEach((canvas) => {
            const img = document.createElement("img");
            img.src = canvas.toDataURL("image/png");
            img.style.width = canvas.style.width;
            img.style.height = canvas.style.height;
            img.className = "chart-image";
            canvas.replaceWith(img);
        });
    };

    const copyAllStyles = () => {
        let styles = "";
        for (let sheet of document.styleSheets) {
            try {
                if (sheet.href) {
                    styles += `<link rel="stylesheet" href="${sheet.href}" />`;
                } else if (sheet.cssRules) {
                    // inline style blocks (used by SCSS injected styles)
                    let rules = "";
                    for (let rule of sheet.cssRules) {
                        rules += rule.cssText;
                    }
                    styles += `<style>${rules}</style>`;
                }
            } catch (err) {
                console.log("Skipping stylesheet", err);
            }
        }
        return styles;
    };

    const DownloadPDF = async () => {
        try {
            const payload = {
                userTypeId: items?.userTypeId || 0,
                userId: items?.userId || 0,
                reportType: "Principal Report Card SAMAGRA",
                contestCreationId: SelectDate?.value || 0,
                assessmentTypeId: 3 || 0
            };
            await axiosInstance.post("/NCLAdmin/InsertReportExportLog", payload);

        } catch (error) {
            console.error("Error logging report download:", error);
        }
        const stylesheets = copyAllStyles();
        replaceCanvasWithImages();
        const printContents = ReportsRef.current.innerHTML;
        const printWindow = window.open("", "", "height=800,width=600");
        const filename = `NCP_ReportCard_${items?.fullName}_${AssessmentName(
            location?.state?.AType,
        )}_${SelectDate?.examStartDate}`;
        printWindow.document.write(`
    <html>
      <head>
      ${stylesheets}
        <style>
          /* General styles for print */
          @media print {
            body {
            font-size: 12px;
              position: relative;
               -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
            }
           
 
  .print-only {
    display: block !important;
  }
    
    table th {
     font-size: 12px;

  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}
  table tbody td,.ft-18 {
  font-size: 12px !important;
}
            /* Watermark style */
            .watermark {
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-55deg);
              font-size: 80px;
              color: rgba(0, 0, 0, 0.06); /* low opacity */
              pointer-events: none;
              z-index: 9999;
              white-space: nowrap;
            }
            
            .Icons-Div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  gap: 20px;
}
.subject-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
}
.Icons-Div div {
  flex: 1;
  text-align: center;
}
  .RC_Details,.RC_Details div div{
  gap:5px !important;}
   .RC_Details div div div{
   padding: 5px!important;}
.Icons-Div img {
              width: 20%;
              // height: 60px;
            }
             
                   .EndReport{
                  margin-top: 15px;
              }
                   .SubHeading,.MainHeading{
 font-weight:700 !important;
 font-size: 14px;}

      
            /* Ensure watermark appears on every page */
            @page {
              size: A4;
              margin: 7mm;
            }
          }
        </style>
      </head>
      <body>
      <div class="p-3 m-2" style="border: 2px solid #2f6e56; border-radius: 20px;">
      <div class="Icons-Div">
       <img src="${NSFLOgo}" alt="NSF Logo"/>
       <div class="">
       <div class="MainHeading" style="color: #2f6e56; font-size: 20px;">SCHOOL PERFORMANCE REPORT</div>
       <div class="MainHeading" style="color: #6b7280">SAMAGRA Assessment - Principal Summary </div>
         </div>
       <div></div>
      </div>
<hr/>

        <div class="dflex JSBetween gap-3 ">
            <div class="dflex flexd-column " style="white-space: nowrap;"><b class="dflex alignitems gap-1" style=" color: #5b8c7e">${renderToString(<FaPenToSquare />)}SCHOOL</b> <b style="color:#2350d3">${items?.fullName}</b> </div>
            <div class="dflex flexd-column " style="white-space: nowrap;"><b class="dflex alignitems gap-1" style="color: #5b8c7e">${renderToString(<HiMiniIdentification />)}ASSESSMENT</b> <b>${SelectDate?.display} - ${SelectDate?.examStartDate}</b> </div>
            <div class="dflex flexd-column " style="white-space: nowrap;"><b class="dflex alignitems gap-1" style="color: #5b8c7e"> ${renderToString(<FaGraduationCap />)}GRADE ASSESSED</b> <b>Grade 1 - Grade 10</b> </div>
          </div>
          </div>
        <div class="watermark">NORTH SOUTH FOUNDATION</div>
   
      ${printContents}
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
     

<div className="dflex flexd-column">
      <span className="">
        Generated by <strong>NorthSouth Foundation</strong> · Samagra Assessment
      </span>
</br>
      <span style="color:#a4b0c2">Confidential Student Record</span>
</br>

      <span style="color:#a4b0c2" >Printed on: <b  style="color:#64748b">${format(new Date(), "dd MMM yyyy")}</b></span>
</br>

      <span style="color: #2f6f57" > www.northsouth.org </span>
    </div>

      <script>
          window.onload = function() {
            setTimeout(() => {
              document.title = "${filename}";
              window.print();
              window.close();
              }, 400);
              }
              <\/script>
              </body>
              </html>
              `);
        printWindow.document.close();
    };
    return (
        <>
            <div className="Instructions-pages p-4">
                <div className="p-3 mb-3" style={{ border: "2px solid #2f6e56", borderRadius: "20px" }}>
                    <div className="dflex JSBetween alignitems">
                        <div></div>
                        <div className="dflex JCCenter flexd-column gap-2 alignitems" style={{ position: "relative", left: "5%" }}>
                            <div className="MainHeading mt-2" style={{ color: "#2f6e56" }}> SCHOOL PERFORMANCE REPORT </div>
                            <div className="SubHeading"> SAMAGRA Assessment - Principal Summary </div>
                            {/* <div className="SubHeading"> {location?.state?.AssTypeNo} Assessment {location?.state?.Date} </div> */}
                        </div>
                        <button className="Buttons p-2" onClick={() => { SPD?.length > 0 && DownloadPDF() }}> Download Report</button>
                    </div>
                    <hr />
                    <div className="dflex JSBetween ">
                        <div className="dflex flexd-column alignitems">
                            <b className="dflex alignitems JCCenter gap-2" style={{ color: "#5b8c7e" }}> <FaSchool /> SCHOOL </b>
                            <b style={{ color: "#2350d3" }}>{items?.fullName}</b>
                        </div>

                        <div className="dflex flexd-column alignitems" >
                            <b className="dflex alignitems JCCenter gap-2" style={{ color: "#5b8c7e" }}> <FaPenToSquare /> ASSESSMENT </b>
                            <b >{SelectDate?.display}</b>
                        </div>
                        <div className="dflex flexd-column alignitems">
                            <b className="dflex alignitems JCCenter gap-2" style={{ color: "#5b8c7e" }}> <FaGraduationCap /> GRADE ASSESSED </b>
                            <b> Grade 1 - Grade 10</b>
                        </div>

                    </div>
                </div>
                {SPD?.length > 0 ?
                    <div ref={ReportsRef}>


                        <div className="dflex JSBetween mt-3 mb-2">
                            <div className="MainHeading">Registration & Participation</div>
                            <div className="PInsights dflex gap-3">
                                <div><span style={{ color: "#166434" }}>Good</span> <span><b>above 75%</b></span></div>
                                <div><span style={{ color: "#b35208" }}>Moderate</span> <span><b>50 - 75%</b></span></div>
                                <div><span style={{ color: "#b81c1c" }}>Low</span> <span><b>below 50%</b></span></div>
                            </div>
                        </div>

                        <div className=" w-100  registration-container">
                            <table className="w-100 registration-table">
                                <thead>
                                    <tr> <th>GRADE</th>
                                        {SPD.map((grade) => (<th key={grade}>{grade?.grade}</th>))}
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr> <td className="row-title">Enrolled</td>
                                        {SPD.map((item, index) => (<td key={index}>{item?.registered}</td>))}
                                    </tr>

                                    <tr> <td className="row-title">Assessed</td>
                                        {SPD.map((item, index) => (<td className="blue" key={index}> {item?.participated} </td>))}
                                    </tr>

                                    <tr> <td className="row-title">Participation %</td>
                                        {SPD.map((item, index) => (
                                            <td className="green" key={index} style={{ color: Percentagecolor(item?.participatedPercentage) }}> {item?.participatedPercentage}% </td>))}
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="dflex JSBetween mt-3 mb-2">
                            <div className="MainHeading">School Snapshot</div>
                            <div className="PInsights dflex gap-3">
                                <div><span style={{ color: "#166434" }}>Competent</span> <span><b>Passed all levels</b></span></div>
                                <div><span style={{ color: "#b35208" }}>Bridge the Gap</span> <span><b>Passed 2+ levels</b></span></div>
                                <div><span style={{ color: "#b81c1c" }}>Remediation Need</span> <span><b>Passed Under 2</b></span></div>
                            </div>
                        </div>

                        <div className="dflex gap-3 ">
                            {SSS.map((card, index) => (
                                <div className={`snapshot-card w-100 ${card.color}`} key={index}
                                    style={{ backgroundColor: InsightsColor(card.performanceLevel)?.[2], color: InsightsColor(card.performanceLevel)?.[0], borderLeft: `5px solid ${InsightsColor(card.performanceLevel)?.[1]}` }}
                                >
                                    <div className="card-header">
                                        <span className="icon">{InsightsColor(card.performanceLevel)?.[3]}</span>
                                        <span className="title">{card.performanceLevel}</span>
                                    </div>

                                    <div className="value">
                                        {card.percentage} {!card.percent && "%"}
                                        {card.percent && (<span className="percent">{Math.round((card.percentage/card?.totalUsers)*100)}%</span>)}
                                    </div>

                                    <div className="subtitle"> {card.percent && "of"} {card?.totalUsers} {InsightsColor(card.performanceLevel)?.[4]}</div>
                                </div>
                            ))}
                        </div>


                        <div className="dflex JSBetween mt-3 mb-2">
                            <div className="MainHeading">Subject Readiness Distribution</div>
                            <div></div>
                        </div>

                        <div className="subject-grid">
                            {Readiness?.map((subject, index) => (
                                <div className={`subject-card ${subject.color}`} key={index}>
                                    <div className="subject-header dflex alignitems">
                                        <div className="left">
                                            <span className="subject-icon">{SubColors(subject?.subjectName)[2]}</span>
                                            <span className="fs-3">{subject.subjectName}</span>
                                        </div>

                                        <div className="avg"> Avg score {subject.averageScore}% • {subject.totalStudents} students </div>
                                    </div>

                                    <div className="progress">
                                        <div className="green-bar" style={{ width: `${subject.competentPercentage}%` }} ></div>
                                        <div className="orange-bar" style={{ width: `${subject.bridgetheGapPercentage}%` }}></div>
                                        <div className="red-bar" style={{ width: `${subject.remediationNeedPercentage}%` }} ></div>
                                    </div>

                                    <div className="legend">

                                        <div className="dflex JSBetween">
                                            <div className="label"> <FaSquare className="green-box" /> Competent </div>
                                            <span className="green-text"> {subject.competentCount} ({subject.competentPercentage}%) </span>
                                        </div>

                                        <div className="dflex JSBetween">
                                            <div className="label"> <FaSquare className="orange-box" /> Bridge the Gap </div>
                                            <span className="orange-text"> {subject.bridgetheGapCount} ({subject.bridgetheGapPercentage}%) </span>
                                        </div>

                                        <div className="dflex JSBetween">
                                            <div className="label"> <FaSquare className="red-box" /> Remediation Need </div>
                                            <span className="red-text">{subject.remediationNeedCount} ({subject.remediationNeedPercentage}%) </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="dflex JSBetween mt-3 mb-2">
                            <div className="MainHeading">Grade-wise Achievement Level</div>
                            <div></div>
                        </div>

                        <div className="achievement-wrapper">
                            {Object.keys(LLD)?.map((subject, index) => (
                                <div className={`achievement-card `} key={index} >
                                    <div className="achievement-header">
                                        <div className="subject-name">
                                            <span>{SubColors(subject)[2]}</span>
                                            <span className="fs-3">{subject}</span>
                                        </div>
                                    </div>

                                    <table className="achievement-table">
                                        <thead>
                                            <tr> <th className="grade">GRADE</th> <th className="level">AT GRADE LEVEL</th>
                                                <th className="y1">1 YR BELOW</th> <th className="y2">2 YRS BELOW</th>
                                                <th className="y3">3 YRS BELOW</th> <th className="y4">4 YRS BELOW</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {LLD[subject].map((row, i) => (
                                                <tr key={i}>
                                                    <td className="gradeName"> Grade {row.grade}</td>
                                                    <td className={row.atGradeLevel != "-" && "levelCell"}>{row.atGradeLevel}</td>
                                                    <td className={row.oneYrBelow != "-" && "y1Cell"}>{row.oneYrBelow}</td>
                                                    <td className={row.twoYrsBelow != "-" && "y2Cell"}>{row.twoYrsBelow}</td>
                                                    <td className={row.threeYrsBelow != "-" && "y3Cell"}>{row.threeYrsBelow}</td>
                                                    <td className={row.fourYrsBelow != "-" && "y4Cell"}>{row.fourYrsBelow}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ))}

                        </div>
                        <p className="mt-2" style={{ fontSize: "14px", color: "#6b7280" }}> Student counts by achievement level - {""}
                            <span style={{ color: "#16a34a", fontWeight: 600 }}>green</span> = at grade level,{" "}
                            <span style={{ color: "#d97706", fontWeight: 600 }}>amber</span> = 1–2 years below,{" "}
                            <span style={{ color: "#dc2626", fontWeight: 600 }}>red</span> = 3–4 years below.{" "}Dash (-) = no students at that level.
                        </p>

                        <div className="dflex JSBetween mt-3 mb-2">
                            <div className="MainHeading">Grade-wise Focus Areas</div>
                            <div></div>
                        </div>

                        <p className="mt-2" style={{ fontSize: "14px", color: "#6b7280" }}>
                            Bottom three learning objectives (LOs) per grade, with each LO&apos;s average
                            score  - {""}
                            <span style={{ color: "#16a34a", fontWeight: 600 }}>green</span> above 75%,{" "}
                            <span style={{ color: "#d97706", fontWeight: 600 }}>amber</span> 50–75%,{" "}
                            <span style={{ color: "#dc2626", fontWeight: 600 }}>red</span> below 50%.
                        </p>

                        {Object.keys(FAD)?.map((FA) => (
                            <>
                                <h2>{SubColors(FA)[2]} {FA} Focus Area</h2>
                                <div className="grid ">
                                    {Object.keys(FAD[FA])?.map((Grade) => (
                                        <div className="card">
                                            <b className="fs-3">Grade {Grade}</b>
                                            <hr />
                                            {FAD[FA][Grade].map((item, index) => (
                                                <div className=" dflex JSBetween alignitems mb-2" key={index}>
                                                    <span>{item.lo}</span>
                                                    <span className="score" style={{ color: Percentagecolor(item.subjectAveragePercentage) }} >
                                                        {item.subjectAveragePercentage}%
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </>
                        ))}
                    </div>
                    :
                    <div className="ErrorMessage"> {process.env.REACT_APP_NODATAFOUND_Participated} </div>
                }
            </div>
        </>
    )
}
export default SamagaraReportCard;